module.exports = __webpack_public_path__ + "img/logo.63425109.svg";